import { useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from '../api';
import { getCustomer } from '../services/customerService';
import { useCart } from '../context/CartContext';
import { useFavorites } from '../context/FavoriteContext';
export const CUSTOMER_INTENT = 'maxmarket.customer.intent';
export function parseItems(value) { try { const items = typeof value === 'string' ? JSON.parse(value) : value; return Array.isArray(items) ? items : []; } catch { return []; } }
export default function useCustomerAction() {
  const navigate = useNavigate(), location = useLocation(), pending = useRef(false);
  const [error, setError] = useState('');
  const { dispatch: cart } = useCart(), { dispatch: favorites } = useFavorites();
  const run = async (intent, action) => {
    if (pending.current) return false;
    pending.current = true; setError('');
    const login = () => {
      const to = intent.type === 'choose-size' ? `/product/${intent.productId}?chooseSize=1` : location.pathname + location.search;
      sessionStorage.setItem(CUSTOMER_INTENT, JSON.stringify({ ...intent, to, createdAt: Date.now() }));
      const reasons = {
        favorite: 'Войдите, чтобы сохранить товар в избранное',
        'favorite-seller': 'Войдите, чтобы сохранить продавца в избранное',
      };
      navigate('/profile', { state: { from: to, loginReason: reasons[intent.type] || 'Войдите, чтобы добавить товар в корзину' } });
    };
    try {
      if (!getCustomer()?.phone || !localStorage.getItem('customerAccessToken')) { login(); return false; }
      let profile;
      try { profile = (await api.get('/api/auth/profile')).data; }
      catch (e) { if ([401, 403].includes(e.response?.status)) { login(); return false; } throw e; }
      if (!profile?.phone) throw new Error('Invalid customer profile');
      cart({ type: 'HYDRATE_CART', payload: parseItems(profile.cart), ownerPhone: profile.phone });
      favorites({ type: 'HYDRATE_FAVORITES', payload: parseItems(profile.favorites), ownerPhone: profile.phone });
      await action(); return true;
    } catch { setError('Не удалось проверить вход. Проверьте подключение и повторите действие.'); return false; }
    finally { pending.current = false; }
  };
  run.error = error;
  return run;
}
